
<mat-form-field>
    <mat-label>Types</mat-label>
    <mat-select [formControl]="types" [multiple]="isMultiple" required>
      <mat-option *ngFor="let type of typeList" [value]="type">{{type}}</mat-option>
    </mat-select>
  </mat-form-field>


<button mat-raised-button color="primary" (click)="stopEditing()">Save</button>
<button mat-raised-button color="primary" (click)="revertChanges()">Undo Changes</button>